import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensTankTop = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[13].productName}
				color={product.allGear[13].color}
				size={product.allGear[13].sizes}
				price={product.allGear[13].price}
				img={product.allGear[13].img}
				miniImg1={product.allGear[13].miniImg1}
				miniImg2={product.allGear[13].miniImg2}
				miniImg3={product.allGear[13].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensTankTop;
